angular.module('ui.shell')
    .directive('centrePanelView', function (customTemplateResolver) {
        return {
            restrict: 'E',
            replace: 'true',
            templateUrl: 'app/ui/shell/views/centrePanel.html' // customTemplateResolver.get('centrePanel.html', 'app/ui/shell/views/centrePanel.html')
        };
    });